/**
 * POST /v1/athletics-availability/respond — an athlete sets/changes their
 * availability for a game or practice.
 *
 * The responder is taken SOLELY from the authenticated request context
 * server-side (plan U8, R7) — the request body intentionally carries NO
 * `userId`/`targetUserId`, so an athlete can only write their own row. The
 * event-start lock and STUDENT-membership authz are enforced server-side
 * (R18/R19); the note cap (R5) is enforced here and again in the service.
 *
 * See: docs/_archive/2026-10-17-plans-sweep/plans/2026-06-16-003-feat-athletics-availability-rsvp-plan.md (U4/U8).
 */

import { z } from 'zod'
import {
  AthleticAvailabilitySchema,
  AthleticAvailabilityStatusSchema,
  ATHLETIC_AVAILABILITY_NOTE_MAX
} from '../../schemas/entities/athletic-availability'

export const RespondAvailabilityRequestSchema = z.object({
  /** Public CUID of the athletic game/practice being responded to. */
  gameId: z.string(),
  /** The athlete's response. */
  status: AthleticAvailabilityStatusSchema,
  /** Optional length-capped note. Untrusted text. */
  note: z.string().max(ATHLETIC_AVAILABILITY_NOTE_MAX).nullable().optional()
})
export type RespondAvailabilityRequest = z.infer<typeof RespondAvailabilityRequestSchema>

export const RespondAvailabilityResponseSchema = z.object({
  data: AthleticAvailabilitySchema
})
export type RespondAvailabilityResponse = z.infer<typeof RespondAvailabilityResponseSchema>
